import BookingApprovalForm from './BookingApprovalForm';
import BookingBranding from './BookingBranding';
import BookingFooter from './BookingFooter';
import BookingStatusScreen from './BookingStatusScreen';

const getContentWidth = (windowSize) => {
    if (windowSize.width < 576) {
        return '100vw';
    }

    return windowSize.width <= 992 ? '75%' : '50%';
};

const ConfirmBookingPage = (controller) => (
    <div className="d-flex flex-column justify-content-start align-items-center" style={{ minHeight: '100vh', width: '100vw', backgroundColor: '#0E94C3' }}>
        <div
            className="card d-flex flex-column justify-content-center flex-grow-1 align-items-center p-3 pb-5"
            style={{ minWidth: getContentWidth(controller.windowSize), minHeight: '100vh' }}
        >
            {controller.isSuccess ? (
                <BookingStatusScreen policyId={controller.formData.HospitalPoliciesId} />
            ) : controller.isDataFetched ? (
                <div>
                    <BookingBranding
                        hospitalImage={controller.hospitalImage}
                        hospitalLogo={controller.hospitalLogo}
                        hospitalName={controller.hospitalName}
                    />
                    {controller.formData.HospitalPoliciesId ? (
                        <BookingApprovalForm {...controller} />
                    ) : (
                        <div className="spinner-border text-primary mt-4" role="status"><span className="visually-hidden">Loading...</span></div>
                    )}
                    <BookingFooter logo={controller.ohoLogo} />
                </div>
            ) : (
                <div className="spinner-border text-primary mt-4" role="status"><span className="visually-hidden">Loading...</span></div>
            )}
        </div>
    </div>
);

export default ConfirmBookingPage;
